import React from 'react';
import Layout from '../../components/Layout';
import { useAuth } from '../../context/AuthContext';
import './CumulDetailleResultsView.css';

const ROWS_PER_CHUNK = 50;

const fmt = (n) => (n || 0).toLocaleString('en-US', { minimumFractionDigits: 2 });

const chunk = (arr, size) => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) chunks.push(arr.slice(i, i + size));
  return chunks;
};

const TableHeader = () => (
  <thead>
    <tr>
      <th>Banque (ID POS)</th>
      <th>Entreprise / Username</th>
      <th>Vendu</th>
      <th>Gain</th>
      <th>Commission</th>
      <th>Épargne</th>
      <th>Tax</th>
      <th>Profit/Perte</th>
    </tr>
  </thead>
);

const CumulDetailleResultsView = ({
  rows, grandTotal, dateFrom, dateTo, loterieLabel, generatedAt, onBack, onExcel,
}) => {
  const { company } = useAuth();
  const chunks = chunk(rows, ROWS_PER_CHUNK);
return (
    <Layout>
      <div className="cdr-toolbar">
        <p className="cdr-back" onClick={onBack}>◀ Back to Search</p>
        {rows.length > 0 && (
          <button type="button" className="cdr-excel-btn" onClick={onExcel}>⬇ Excel</button>
        )}
      </div>

      <div className="cdr-page">
        <div className="cdr-masthead">
          <span className="cdr-company">{company?.name || ''}</span>
          <span className="cdr-today">{dateTo}</span>
        </div>
        <div className="cdr-masthead">
          <span className="cdr-report-title">Ventes Cumulees detaillee par Banque</span>
          <span className="cdr-timestamp">{generatedAt}</span>
        </div>
        <p className="cdr-range">De: {dateFrom} A: {dateTo} | Loterie :{loterieLabel}</p>

        {rows.length === 0 && <p className="cdr-empty">Aucune vente sur cette periode.</p>}

        {chunks.map((rowsChunk, ci) => (
          <table key={ci} className="cdr-table">
            <TableHeader />
            <tbody>
              {rowsChunk.map((row) => (
                <tr key={row.bank_id}>
                  <td>{row.bank_seq} - {row.bank_name}</td>
                  <td>{row.bank_username || row.device_serial ? `${row.company_name} (${row.bank_username || row.device_serial})` : row.company_name}</td>
                  <td>{fmt(row.vendu)}</td>
                  <td>{fmt(row.gagne)}</td>
                  <td>{fmt(row.commission)}</td>
                  <td>{fmt(row.epargne)}</td>
                  <td>—</td>
                  <td>{fmt(row.total)}</td>
                </tr>
              ))}
              {ci === chunks.length - 1 && grandTotal && (
                <tr className="cdr-total-row">
                  <td colSpan={2}><strong>Total:</strong></td>
                  <td><strong>{fmt(grandTotal.vendu)}</strong></td>
                  <td><strong>{fmt(grandTotal.gagne)}</strong></td>
                  <td><strong>{fmt(grandTotal.commission)}</strong></td>
                  <td><strong>{fmt(grandTotal.epargne)}</strong></td>
                  <td><strong>—</strong></td>
                  <td><strong>{fmt(grandTotal.total)}</strong></td>
                </tr>
              )}
            </tbody>
          </table>
        ))}

        <p className="cdr-count">Total Count: {rows.length}</p>
      </div>
    </Layout>
  );
};

export default CumulDetailleResultsView;
